import connectionBO from "../../services/connectionBO";

export const categories = {
    namespaced: true,
    state: {
        categories: []
    },
    mutations: {
        LISTCAT_BYSECTION: (state, categories) => {
            state.categories = categories;
        }
    },
    getters: {
        getCategories: state => state.categories
    },
    actions: {
        listCatBySection(context, value) {
            return connectionBO.getCategoriesList(value).then(response => {
                context.commit("LISTCAT_BYSECTION", response.data);
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/categories/CategoriesStore.js